<template>
  <main v-if="true" :class="{'boxPadding': isBox}">
    <customer-info :loading="false"/>
    <tab-header :current="currentTab"/>
    <div class="tab-content">
      <div class="container-fluid">
        <div class="tab-pane active show">
          <div class="form-group">
            <div class="radio radio-inline">
              <input type="radio" name="progress" v-model="progress" id="progress-1" value="1">
              <label for="progress-1">新契約({{isLoading_1? '?': progressData.length}})</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="progress" v-model="progress" id="progress-2" value="2" >
              <label for="progress-2">理賠({{isLoading_2 ? '?': claimData.length}})</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="progress" v-model="progress" id="progress-3" value="3">
              <label for="progress-3">保全({{isLoading_3 ? '?': changeData.length}})</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="progress" v-model="progress" id="progress-4" value="4">
              <label for="progress-4">整合行銷({{isLoading_4 ? '?': MarketingData.length}})</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="progress" v-model="progress" id="progress-5" value="5">
              <label for="progress-5">放款({{isLoading_5 ? '?': loanData.length}})</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="progress" v-model="progress" id="progress-6" value="6">
              <label for="progress-6">保費({{isLoading_6 ? '?': premiumData.length}})</label>
            </div>
          </div>
          <div v-if="progress==1"
          :class="{
                'section-loading': isLoading_1
          }">
            <div class="insurance-row row" v-if="progressData.length != 0">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th width="150">受理編號</th>
                    <th width="70">被保人</th>
                    <th width="70">要保人</th>
                    <th width="150">保單號碼</th>
                    <th width="150">受理日期</th>
                    <th width="60">險別</th>
                    <th>受理進度</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(item, i) in progressData"
                  :key="`progress-data-${i}`">
                    <td>{{item.no}}</td>
                    <td>{{item.target}}</td>
                    <td>{{item.client}}</td>
                    <td>{{item.insuranceNo}}</td>
                    <td>{{item.date | dateFormat}}</td>
                    <td>{{item.type}}</td>
                    <td v-html="item.status"></td>
                     <!-- {{item.status}} -->
                      <!-- <span v-if="item.status===1">已上傳<br/>待繳費</span> -->
                  </tr>
                </tbody>
              </table>
             <p class="pl-2">＊系統更新時間為每日03:00~03:30、12:00~12:30和18:30~19:00</p>
            </div>
            <div v-else class="text-center" colspan="6">
              <h3 class="mb-3"><center>查無資料</center></h3>
            </div>
          </div>
          <div v-if="progress==2"
          :class="{
                'section-loading': isLoading_2
          }">
            <div class="insurance-row row" v-if="claimData.length != 0">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th>受理編號</th>
                    <th width="70">事故人ID</th>
                    <th width="70">事故人姓名</th>
                    <th>受理單位</th>
                    <th>受理日期</th>
                    <th>核賠人員/電話</th>
                    <th>受理進度</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(item, i) in claimData"
                  :key="`claim-data-${i}`">
                    <td>{{item.APLY_NO}}</td>
                    <td>{{item.OCR_ID}}</td>
                    <td>{{item.OCR_NAME}}</td>
                    <td>{{item.APLY_DIV_NAME}}</td>
                    <td>{{item.APLY_DATE | replaceDash}}</td>
                    <td>{{item.DECD_EMP_NAME}}<br>{{item.DECD_EXT | getPhoneNum}}<br>#{{item.DECD_EXT | getPhoneExt}}</td>
                    <td>{{item.APLY_STS_NAME}}</td>
                  </tr>
                </tbody>
              </table>
            <p class="pl-2">
              1.案件進度「作廢」或「剔除」多為重複送件，或人員另起一案受理，若有疑慮可洽服務中心或理賠科詢問。<br/>
              2.部分案件結案若無顯示「給付明細」或電子給付明細無法閱讀，請向理賠科索取。<br/>
              3.該畫面僅查詢結後20天內之資料，欲查詢歷史案件請至<a href="https://was3.cathaylife.com.tw/AAWeb/servlet/HttpDispatcher/SysLogin/prompt">理賠進度</a>查詢
            </p>
            </div>
            <div v-else class="text-center" colspan="6">
              <h3 class="mb-3"><center>查無資料</center></h3>
            </div>
            
          </div>
          <div v-if="progress==3"
          :class="{
                'section-loading': isLoading_3
          }">
            <div class="insurance-row row" v-if="changeData.length != 0">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th>受理編號</th>
                    <th width="70">要保人</th>
                    <th width="70">被保人</th>
                    <th>險別</th>
                    <th>受理日期</th>
                    <th>保單號碼</th>
                    <th>服務項目</th>
                    <th>受理進度</th>
                    <th>預估完成日期</th>
                    <th>受理人員</th>
                    <th>備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(item, i) in changeData"
                  :key="`change-data-${i}`">
                    <td>{{item.APLY_NO}}</td>
                    <td>{{item.APC_NAME}}</td>
                    <td>{{item.INSD_NAME}}</td>
                    <td>{{item.PROD_NAME}}</td>
                    <td>{{item.APLY_DATE | dateFormat}}</td>
                    <td>{{item.POLICY_NO}}</td>
                    <td>{{item.TRN_KIND_CH}}</td>
                    <td>{{item.APLY_STS_CH}}</td>
                    <td>{{item.EFT_DATE | dateFormat}}</td>
                    <td>{{item.INPUT_NAME}}</td>
                    <td>{{item.ACPT_BANK_NO_CH}}<br>{{item.ACPT_ACNT_NO}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center" colspan="7">
              <h3 class="mb-3"><center>查無資料</center></h3>
            </div>
          </div>
          <div v-if="progress==4"
          :class="{
                'section-loading': isLoading_4
          }">
          <div class="insurance-row row" v-if="MarketingData.length != 0">
            <table class="table insurance-green">
              <thead>
                <tr>
                  <th width="100">客戶姓名</th>
                  <th>信用卡種類</th>
                  <th width="70">正/附卡</th>
                  <th width="110">銀行收件日</th>
                  <th>受理狀態</th>
                  <th width="110">核/製卡日</th>
                  <th width="110">開卡日</th>
                  <th width="110">動用日</th>
                  <th>發佣狀態</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in MarketingData" :key="`Marketing-Data-${i}`">
                  <td>{{item.name}}</td>
                  <td>{{item.cardkindnm}}</td>
                  <td>{{item.crshp}}</td>
                  <td>{{item.tdte | dateFormat}}</td>
                  <td v-if="item.codedesc.length != 0">
                    <a class="link text-underline" @click="openMaketingDataModal(item)">{{item.handle}}</a>
                    </td>
                  <td v-else>{{item.handle}}</td>
                  <!-- <td>{{item.handle}}</td> -->
                  <td>{{item.cdte | dateFormat}}</td>
                  <td>{{item.sdte | dateFormat}}</td>
                  <td>{{item.bdte | dateFormat}}</td>
                  <td v-html="item.cecobcd_nm"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center" colspan="6">
              <h3 class="mb-3"><center>查無資料</center></h3>
            </div>
          </div>
          <div v-if="progress==5"
          :class="{
                'section-loading': isLoading_5
          }">
            <div v-show="!loanData.length" class="text-center"><h3 class="mb-3"><center>查無資料</center></h3></div>
            <div class="insurance-row row">
              <div v-for="(item, i) in loanData"
              :key="`loan-data-${i}`">
                <table class="table insurance-green">
                  <thead>
                    <tr>
                      <th>受理編號</th>
                      <th>借款人</th>
                      <th>受理進度</th>
                      <th width="80">經手人員</th>
                      <th>受理日期</th>
                      <th>承辦科別</th>
                      <th>輸入人員</th>
                      <th>是否需核貸前補全</th>
                      <th>承辦人員</th>
                      <th>匯款人員</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td>{{item.APPLY_ID}}</td>
                      <td>{{item.BORROW_NAME}}</td>
                      <td>{{item.APPLY_PROCESS_NM}}</td>
                      <td>{{item.AGENT_NAME}}</td>
                      <td>{{item.APPLY_DATE | dateFormat}}</td>
                      <td>{{item.CRED_DEPT_NM}}</td>
                      <td>{{item.INPUT_NAME}}</td>
                      <td>{{item.SUPPLY == 'Y'? ``: `不`}}需核貸前補全</td>
                      <td>{{item.CRED_NM}}</td>
                      <td>{{item.REMIT_NM}}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>包裹日期</th>
                      <th width="70">鑑價覆核</th>
                      <th width="70">簽件日期</th>
                      <th width='70'>核貸日期</th>
                      <th>對保日期</th>
                      <th>一匯日期</th>
                      <th class="text-center">借款金額<br/>(萬)</th>
                      <th class="text-center">核貸金額<br/>(萬)</th>
                      <th width='70'>承辦人員電話</th>
                      <th width="70">匯款人員電話</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td>{{item.PACK_DATE | dateFormat}}</td>
                      <td>{{item.REPORT_DATE | dateFormat}}</td>
                      <td>{{item.SCRIBE_DATE | dateFormat}}</td>
                      <td>{{item.AGREE_DATE | dateFormat}}</td>
                      <td>{{item.GUARANTOR_DATE | dateFormat}}</td>
                      <td>{{item.REMIT1_DATE | dateFormat}}</td>
                      <td class="text-center">{{item.LOAN_AMT}}</td>
                      <td class="text-center">{{item.AGREE_AMT}}</td>
                      <td>{{item.CRED_TEL}}</td>
                      <td>{{item.REMIT_TEL}}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <table class="table insurance-green">
                  <thead>
                    <tr>
                      <th>包裹日期</th>
                      <th>鑑價覆核</th>
                      <th>簽件日期</th>
                      <th>核貸日期</th>
                      <th>對保日期</th>
                      <th>一匯日期</th>
                      <th class="text-right">借款金額（萬）</th>
                      <th class="text-right">核貸金額（萬）</th>
                      <th>承辦人員電話</th>
                      <th>匯款人員電話</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{progressTable.packageDate}}</td>
                      <td>{{progressTable.valuationDate}}</td>
                      <td>{{progressTable.signDate}}</td>
                      <td>{{progressTable.loanDate}}</td>
                      <td>{{progressTable.protectionDate}}</td>
                      <td>{{progressTable.firstDate}}</td>
                      <td class="text-right">{{progressTable.borrowNumber}}</td>
                      <td class="text-right">{{progressTable.loanNumber}}</td>
                      <td>{{progressTable.receiverPhone}}</td>
                      <td>{{progressTable.remittancePhone}}</td>
                    </tr>
                  </tbody>
                </table> -->
              </div>
            </div>
          </div>
          <div v-if="progress==6"
          :class="{
                'section-loading': isLoading_6
          }">
            <div class="insurance-row row" v-if="premiumData.length != 0">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th width="100">授權書編號</th>
                    <th>授權人ID</th>
                    <th width="70">銀行代號</th>
                    <th width="110">幣別</th>
                    <th>處理進度</th>
                    <th width="110">核印結果</th>
                    <th width="110">服務中心退件通知</th>
                    <th width="110">備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(item, i) in premiumData"
                  :key="`premium-data-${i}`">
                    <td>{{item.AUTH_NO}}</td>
                    <td>{{item.AUTH_ID}}</td>
                    <td>{{item.BANK_NAME}}</td>
                    <td>{{item.CURRTYPE}}</td>
                    <td>{{item.STATUS}}</td>
                    <td>{{item.CFM_STS}}</td>
                    <td>{{item.RJT_STS}}</td>
                    <td>{{item.MEMO}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center" colspan="6">
              <h3 class="mb-3"><center>查無資料</center></h3>
            </div>
            </div>
        </div>
      </div>
    </div>
    
    <marketing-data-modal
    :open="marketingDataOpen"
    :inputs='codedescData'
    @close="panelClose('marketingDataOpen')"/>
    <!-- Modal -->
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import { commonMixin } from '../../mixins/common';

import { queryProgressNewConTract } from '../../service';
import { queryProgressLoan } from '../../service';
import { queryPayRecord } from '../../service'
import { queryPremiumRecord } from '../../service'
import { queryInsuranceClaimRecord } from '../../service'
import { queryIntegratedMarketing } from '../../service'

import MarketingDataModal from '../components/MarketingDataModal';
import Avatar from '../../components/Avatar';
import CustomerInfo from '../components/CustomerDetail/CustomerInfo';
import TabHeader from '../components/CustomerDetail/TabHeader';

export default {
  name: 'CustomerDetail6',
  mixins: [commonMixin],
  data () {
    return {
      isLoading_1: false,
      isLoading_2: false,
      isLoading_3: false,
      isLoading_4: false,
      isLoading_5: false,
      isLoading_6: false,
      currentTab: 0,
      progress: 1,
      progressData: [],
      loanData: [],
      changeData: [],
      premiumData: [],
      claimData: [],
      MarketingData:[],
      marketingDataOpen: false,
      codedescData:{},
    }
  },
  components: { 
    Avatar, CustomerInfo, TabHeader,MarketingDataModal // basic component  
  },
  watch: {
    progress () {
      this.registerHanlink()  // for hard word
    },
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo']),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === 'box';
    }
  },
  filters: {
    replaceDash: function (val) {
      return val.replace(/\-/g,'/')
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    openMaketingDataModal(MarketingData){
      this.codedescData = MarketingData
      this.panelOpen('marketingDataOpen')
    },
    initCustomerDetail6() {
      this.isLoading_1 = true
      queryProgressNewConTract(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body && result.body.data_list) {
          this.progressData = result.body.data_list.map(item => {
            return {
              no: item.APPLY_NO,
              target: item.INSD_NAME,
              client: item.APC_NAME,
              insuranceNo: item.POLICY_NO,
              type: item.PROD_NM,
              date: item.INPUT_DATE,
              status: item.APLY_STS_ALL
            }
          })
        }
        this.isLoading_1 = false
      })

      this.isLoading_2 = true
      queryInsuranceClaimRecord(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body && result.body.AA_LIST) {
          this.claimData = result.body.AA_LIST.map(item =>{
            return {
              APLY_NO: item.APLY_NO,
              OCR_ID: item.OCR_ID,
              OCR_NAME: item.OCR_NAME,
              APLY_DIV_NAME: item.APLY_DIV_NAME,
              APLY_NAME: item.APLY_NAME,
              APLY_DATE: item.APLY_DATE,
              DECD_EMP_NAME: item.DECD_EMP_NAME,
              DECD_EXT: item.DECD_EXT,
              APLY_STS_NAME: item.APLY_STS_NAME
            }
          })
        }
        this.isLoading_2 = false
      })

      this.isLoading_3 = true
      queryPayRecord(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body && result.body.CHANGE_LIST){
          this.changeData = result.body.CHANGE_LIST.map(item =>{
            return {
              APLY_NO: item.APLY_NO,
              AGNT_NAME: item.AGNT_NAME,
              INSD_NAME: item.INSD_NAME,
              PROD_NAME: item.PROD_NAME,
              APLY_DATE: item.APLY_DATE,
              POLICY_NO: item.POLICY_NO,
              TRN_KIND: item.TRN_KIND,
              TRN_KIND_CH: item.TRN_KIND_CH,
              APLY_STS_CH: item.APLY_STS_CH,
              EFT_DATE: item.EFT_DATE,
              ACPT_BANK_NO_CH: item.ACPT_BANK_NO_CH,
              ACPT_ACNT_NO: item.ACPT_ACNT_NO,
              APC_NAME: item.APC_NAME,
              INPUT_NAME: item.INPUT_NAME || ""
            }
          })
        }
        this.isLoading_3 = false
      })

      this.isLoading_4 = true
      queryIntegratedMarketing(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body){          
           let dataAry = result.body.map(item =>{
            return {
              agidno: item.agidno,
              idno: item.idno,
              name: item.name,
              gpkind: item.gpkind,
              cardkindnm: item.cardkindnm,
              crshp: item.crshp,
              tdte: item.tdte,
              handle: item.handle,
              cdte: item.cdte,
              sdte: item.sdte,
              cecmn: item.cecmn,
              updcode: item.updcode,
              recode: item.recode,
              cecmnym: item.cecmnym,
              cecobcd: item.cecobcd,
              bdte: item.bdte,
              buycmn: item.buycmn,
              buycmnym: item.buycmnym,
              cecobcd_nm: item.cecobcd_nm,
              codedesc: item.codedesc
            }
          })
          dataAry.sort(function(a, b){return (b.tdte > a.tdte)? 1 : -1})
          this.MarketingData = dataAry
          
          if(this.MarketingData.codedesc){
            this.codedescData = this.MarketingData[0].codedesc
          }
        }
        else{
          this.MarketingData = []
        }
        // console.log("MarketingData:"+ this.MarketingData.name);
        
        this.isLoading_4 = false
      })


      this.isLoading_5 = true
      queryProgressLoan(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body && result.body.data_list) {
          this.loanData = result.body.data_list
        } else {
          this.loanData = []
        }
        this.isLoading_5 = false
      })

      this.isLoading_6 = true
      queryPremiumRecord(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body && result.body.AUTH_LIST){
          this.premiumData = result.body.AUTH_LIST.map(item =>{
            return {
              AUTH_ID: item.AUTH_ID,
              AUTH_NO: item.AUTH_NO,
              BANK_NAME: item.BANK_NAME,
              CURRTYPE: item.CURRTYPE,
              STATUS: item.STATUS,
              CFM_STS: item.CFM_STS,
              RJT_STS: item.RJT_STS,
              MEMO: item.MEMO
            }
          })
        }
        this.isLoading_6 = false
      })
    }
  },
  beforeMount () {
    let routeNumber = (this.$route.name.split(/-/g)).reverse()
    this.currentTab = Number(routeNumber[0])
  },
  async mounted () {
    
    this.initCustomerDetail6()
  }
}
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>
